import { rem } from 'polished';
import React from 'react';
import styled from 'styled-components';

import { bokehTheme as theme } from '@vimeo/bokeh-theme';

const Badge = styled.span`
  color: ${theme.colors.gray['200']};
  background-color: ${theme.colors.gray['800']};
  font-size: ${rem(10)};
  font-weight: bold;
  letter-spacing: ${rem(0.11)};
  line-height: ${rem(18)};
  text-transform: uppercase;
  padding: 0 ${rem(5)};
  height: ${rem(19)};
  vertical-align: super;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: inline-block;
  margin: 0 0 ${rem(9)};
`;

const EssentialsBadge: React.FC = () => {
  return <Badge>Essentials</Badge>;
};

export default EssentialsBadge;
